import { createTheme } from "@mui/material/styles";

const defaultTheme = createTheme();

export const darkTheme = createTheme({
    palette: {
        mode: "dark", // Assuming a dark theme based on background color
        primary: {
            main: "rgb(177, 198, 255)",
            contrastText: "rgb(0, 44, 112)",
            dark: "rgb(27, 67, 143)",
            light: "rgb(217, 226, 255)",
        },
        secondary: {
            main: "rgb(224, 113, 133)",
            contrastText: "rgb(104, 0, 17)",
            dark: "rgb(146, 0, 28)",
            light: "rgb(255, 218, 216)",
        },
        error: {
            main: "rgb(186, 26, 26)",
            contrastText: "rgb(255, 255, 255)",
            dark: "rgb(147, 0, 10)",
            light: "rgb(255, 180, 171)",
        },
        background: {
            default: "rgb(23, 25, 28)",
            paper: "rgb(29, 32, 36)",
        },
        header: {
            background: "rgb(23, 25, 28)",  // Same as background.default
            text: "rgb(228, 226, 230)", // Same as text.primary
        },
        text: {
            primary: "rgb(228, 226, 230)",
            secondary: "rgb(197, 198, 208)",
            disabled: "rgba(228, 226, 230, 0.38)",
        },
        divider: "rgb(59, 59, 59)",
        action: {
            disabled: "rgba(228, 226, 230, 0.38)",
            disabledBackground: "rgba(228, 226, 230, 0.12)",
        },
    },
    shadows: [
        "none",
        "0px 1px 3px 0px rgb(23, 25, 28)",
        "0px 1px 5px 0px rgb(29, 32, 36)",
        "0px 1px 8px 0px rgb(68, 70, 79)",
        "0px 2px 4px -1px rgb(143, 144, 153)",
        "0px 3px 5px -1px rgb(56, 49, 62)",
        ...defaultTheme.shadows.slice(6),
    ],
    //   overrides: {
    //     MuiOutlinedInput: {
    //       root: {
    //         "& .MuiOutlinedInput-notchedOutline": {
    //           borderColor: "rgb(241, 242, 247)", // Default outline color
    //         },
    //         "&:hover .MuiOutlinedInput-notchedOutline": {
    //           borderColor: "rgb(177, 198, 255)", // Change on hover
    //         },
    //         "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    //           borderColor: "rgb(177, 198, 255)", // Change on focus
    //           borderWidth: "2px",
    //         },
    //       },
    //     },
    //   },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: ".75rem",
                    fontWeight: 'normal',
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundImage: 'none',
                    backgroundColor: '#1c2024',
                }
            }
        }
    }
});


export const lightTheme = createTheme({
  palette: {
    mode: "light", // Light theme
    primary: {
      main: "#1d428a",
      contrastText: "rgb(255, 255, 255)",
      dark: "#172b5b",
      light: "rgb(217, 226, 255)",
    },
    secondary: {
      main: "rgb(191, 2, 41)",
      contrastText: "rgb(255, 255, 255)",
      dark: "rgb(65, 0, 7)",
      light: "rgb(255, 218, 216)",
    },
    error: {
      main: "rgb(186, 26, 26)",
      contrastText: "rgb(255, 255, 255)",
      dark: "rgb(65, 0, 2)",
      light: "rgb(255, 218, 214)",
    },
    background: {
      default: "rgb(254, 251, 255)",
      paper: "rgb(255, 255, 255)",
    },
    header: {
      background: "rgb(29, 66, 138)",
      text: "rgb(255, 255, 255)",
    },
    text: {
      primary: "rgb(29, 32, 36)",
      secondary: "rgb(68, 70, 79)",
      disabled: "rgba(29, 32, 36, 0.38)",
    },
    divider: "rgba(224,224,224,255)",
    action: {
      disabled: "rgba(29, 32, 36, 0.38)",
      disabledBackground: "rgba(29, 32, 36, 0.25)",
    },
  },
  components: {
      MuiTooltip: {
          styleOverrides: {
              tooltip: {
                  fontSize: ".75rem",
                  fontWeight: 'normal',
              }
          }
      }
  }
});
